module.exports = __webpack_public_path__ + "img/eye.0fcc1944.svg";